import Icon from '../components/Icon.vue'

Icon.register({
  torah: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 358.4V25.6C448 9.6 438.4 0 422.4 0H96C41.6 0 0 41.6 0 96V416C0 470.4 41.6 512 96 512H422.4C435.2 512 448 502.4 448 486.4V470.4C448 464 444.8 457.6 438.4 451.2 435.2 435.2 435.2 390.4 438.4 377.6 444.8 374.4 448 368 448 358.4zM139.1 141.2C136.3 136.8 139.5 131.1 144.7 131.1H197.8C198.7 131.1 199.5 130.6 200 129.9L234.4 75.1C237 71 243 71 245.6 75.1L280 129.9A2.6-2.6 0 0 1 282.2 131.1H335.3C340.5 131.1 343.7 136.8 340.9 141.2L314 184 340.9 226.8C343.7 231.2 340.5 236.9 335.3 236.9H282.2C281.3 236.9 280.5 237.4 280 238.1L245.6 292.9C243 297 237 297 234.4 292.9L200 238.2A2.6-2.6 0 0 1 197.8 236.9H144.7C139.5 236.9 136.3 231.2 139.1 226.8L166 184 139.1 141.2zM380.8 448H96C76.8 448 64 435.2 64 416S80 384 96 384H380.8V448z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/torah.js
// module id = pDbn
// module chunks = 144